<template>
  <SysInputFormatadorDeValor
    v-model="props.produto.estoque_min"
    :max-digitos="4"
    remover-valor-irrelevante
    centralizar
    class="input-regular font-resp w-100"
    @focus="$event.target.select()"
    @keydown.enter="validarValor"
    @blur="validarValor"
  />
</template>

<script setup>
import SysInputFormatadorDeValor from "@/components/utils/InputFormatadorDeValor.vue";
import {salvar} from "@/components/drp/AnaliseParametrosProdutoDrp/EstoqueMinimo/utils";

const props = defineProps({
  produto: Object,
});

function validarValor() {
  if (!Number(props.produto.estoque_min) > 0) return;

  const parametros = {
    filiais: [props.produto.filial],
    produtos: [props.produto.idproduto],
    estoque_min: props.produto.estoque_min,
  };

  salvar(parametros);
}
</script>
